module.exports = __webpack_public_path__ + "img/ExampleApplication.4ff9ff34.png";